/**
 * RabbitMQManagementService
 * Service for RabbitMQ management and monitoring
 * Route: api/rabbitmqmanagement
 */
import { BaseService } from '../base/BaseService';
export class RabbitMQManagementService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RabbitMQManagementService.DEFAULT_SERVICE_PATH,
            basePath: RabbitMQManagementService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getConfiguration() {
        const endpoint = this.getEndpoint('configuration', 'configuration');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async getExchanges() {
        const endpoint = this.getEndpoint('exchanges', 'exchanges');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async getConnectionInfo() {
        const endpoint = this.getEndpoint('connection-info', 'connection-info');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async getMessagingPatterns() {
        const endpoint = this.getEndpoint('messaging-patterns', 'messaging-patterns');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async getImplementationStatus() {
        const endpoint = this.getEndpoint('implementation-status', 'implementation-status');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async getConnectionStatus() {
        const endpoint = this.getEndpoint('connection-status', 'connection-status');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async getAllQueueStats() {
        const endpoint = this.getEndpoint('queue-stats', 'queue-stats');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async getQueueStats(queueName) {
        const endpoint = this.getEndpoint('queue-stats-by-name', `queue-stats/${queueName}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async verifyQueueDeletion(queueName) {
        const endpoint = this.getEndpoint('queue-verification', `queue-verification/${queueName}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    async deleteQueue(queueName, force = false) {
        const endpoint = this.getEndpoint('delete-queue', `queues/${queueName}`);
        const url = this.buildUrl(endpoint) + `?force=${force}`;
        return this.http.delete(url);
    }
    async purgeQueue(queueName) {
        const endpoint = this.getEndpoint('purge-queue', `queues/${queueName}/purge`);
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
RabbitMQManagementService.DEFAULT_SERVICE_PATH = 'system';
RabbitMQManagementService.BASE_PATH = 'api/rabbitmqmanagement';
//# sourceMappingURL=RabbitMQManagementService.js.map